import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserFieldValue } from '/src/Util/Util';

const BirthdayYear = (props) => {
	const { t } = useTranslation();

	const {form_component} = props;
	const {fieldname, required} = form_component;

	const fv = useSelector(state => state.fv);
	const userData = useSelector(state => state.userData);
	
	// Determine the user field value for custom profile fields
	let userFieldValue = getUserFieldValue(fieldname, userData);

	useEffect(() => { // to be updated after render
		if (fv && required) {
			fv.addField(`${fieldname}[year]`, {
				validators: {
					notEmpty: {
						message: t('此欄為必須填寫')
					}
				}
			});
		}
	}, [fv]);

	var years = [];
    if (form_component.date_select_na) {
        years[0] = t('不適用');
    }
    for (let i = form_component.year_select_start; i <= form_component.year_select_end; ++i) {
        years[i] = i;
    }

	return (
		<div className="d-flex align-items-center">
			<div className="me-3">
				<div className="mb-3 form-group select">
					<select
						className="form-select-sm w-date form-select"
						defaultValue={userFieldValue && userFieldValue.year ? userFieldValue.year : ''}
						name={`${fieldname}[year]`}
					>
						<option value="">-</option>
						{(() => {
							const components = [];
							
							years.map((year, index) => {
								components.push(
									<option key={`year-${index}`} value={year}>{year}</option>
								);
							});

							return components;
						})()}
					</select>
				</div>
			</div>
			<div className="pb-3">{t('年')}</div>
		</div>
	);
}

export default BirthdayYear;